export enum SubRoutesEnum {
  ALL = 'all',
  COMMITTEES = 'committees',
  COMMON = 'common',
  CREDIT_LINES = 'credit-lines',
  CURRENT = 'current',
  ENDED = 'ended',
  FREE = 'free',
  INSTALLMENT = 'installment',
  LIST = 'list',
  MEETINGS = 'meetings',
  PRACTICES = 'practices',
  RENOVATIVE = 'renovative',
}
